module.exports = __webpack_public_path__ + "img/05—Applications—VPN server II.a84d5f66.jpg";